import gql from 'graphql-tag';
import { parseToMutationRequest } from '../../../utils/utils';

export default data => {
  const dataModify = parseToMutationRequest(data, ['index', 'roundingPrecision', 'grantType', 'roundingMethod']);
  const modifyGrantsConfig = `modifyGrantsConfig(input: ${dataModify})`;

  return gql`
  mutation {
    ${modifyGrantsConfig} {
      id
    }
  }
`;
};
